import cookieHelper from "@irati/utils/cookies"
import EnvVariables from "./interface/env"

function getCookie(COOKIE_NAME: string) {
  try {
    const version = cookieHelper.getItem(COOKIE_NAME) || ""
    return version
  } catch (e) {
    return ""
  }
}

// esbuild doesn't like injected env variables much... this gets round it :shrug:
const env = ENVIRONMENT_NAME
const graphql = getCookie("PBFEGraphUrl") || GRAPH_QL
const apigw = API_GW
const islocal = IS_LOCAL
const getLocal = "localhost"
const bundleref = BUNDLE_REF
const public_url = PUBLIC_URL

export default {
  ENVIRONMENT_NAME: env,
  GRAPH_QL: graphql,
  API_GW: apigw,
  IS_LOCAL: islocal,
  GET_LOCAL: getLocal,
  BUNDLE_REF: bundleref,
  PUBLIC_URL: public_url
} as EnvVariables
